import React, { useEffect } from 'react';
import ChatMenuListPresenter from './ChatMenuListPresenter';

import { useFetchQuotationUserRfqDetailQuery } from '@generated/graphql';

import isDesignService from '@utils/isDesign';
import { useSelector } from '@store';
import useDrawer from '../useDrawer';

import { shallowEqual } from 'react-redux';

interface Props {
  matches: boolean;
}

const ChatMenuContainer = ({ matches }: Props) => {
  const [drawer, updateDrawer] = useDrawer();

  const rfqId = useSelector((state) => state.chat.rfqId ?? '');
  const menuStatus = useSelector(
    (state) => state.chat.menuStatus,
    shallowEqual
  );

  const { data } = useFetchQuotationUserRfqDetailQuery({
    variables: {
      rfqId: rfqId ?? ''
    },
    skip: !rfqId,
    fetchPolicy: 'cache-only'
  });

  const rfqDetail = data?.fetchQuotationUserRfqDetail.data ?? undefined;

  const isDesign = isDesignService(
    rfqDetail?.serviceType ?? undefined,
    rfqDetail?.pcb?.services ?? []
  );

  useEffect(() => {
    if (
      (drawer.menu === 'purchaseorder' && menuStatus?.purchaseOrder) ||
      (drawer.menu === 'create_purchaseorder' && menuStatus?.purchaseOrder)
    ) {
      updateDrawer('init');
    }
  }, [drawer.menu, menuStatus, updateDrawer]);

  return (
    <ChatMenuListPresenter
      matches={matches}
      rfqDetail={rfqDetail}
      isDesign={isDesign}
    />
  );
};

export default ChatMenuContainer;
